const ErrorMessages = [
  'No momento não estamos aceitando cartão de débito para o pagamento da assinatura. Por favor, prossiga com as opções de cartão de crédito, boleto ou pix.',
  'Data de validade inválida.',
  'CVV inválido.',
  'Dados de pagamento inválidos.',
  'Não foi possível efetuar o pagamento. Por favor, verifique se o cartão utilizado é do tipo crédito e está válido.',
  'Não foi possível efetuar o pagamento. Por favor, verifique seus dados e tente novamente.',
  'Número do cartão de crédito inválido.',
  'Este cartão não tem saldo suficiente para a compra.',
  'Transação não permitida. Por favor, tente com outro cartão de crédito.',
  'Transação recusada. Por favor, verifique seus dados e tente novamente.',
  'Cartão inválido. Adicione um novo cartão antes de prosseguir ou entre em contato.',
]

export default ErrorMessages
